(() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.ce_mobile_navigation .level_1_with_subnav > button').forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        button.closest('.level_1_with_subnav').classList.toggle('level_1_with_subnav_open')
        button.closest('li').classList.toggle('subnav_level_2_open')
      })
    })
  })
}) ()